import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AiTutor from "@/components/AiTutor";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <AiTutor />
    </div>
  );
}
